<template>
	<div class="v-tooltip" @mouseenter="show" @mouseleave="hide">
		<slot/>
		<div :aria-hidden="hidden" :class="wrapperClass" class="v-tooltip__wrapper">
			<div class="v-tooltip__content">
				<slot name="popover"/>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			hidden: true,
		};
	},
	computed: {
		wrapperClass() {
			return {
				"v-tooltip__wrapper--top": this.placement === "top",
				"v-tooltip__wrapper--right": this.placement === "right",
				"v-tooltip__wrapper--bottom": this.placement === "bottom",
				"v-tooltip__wrapper--left": this.placement === "left",
			};
		},
	},
	props: {
		placement: {
			required: false,
			type: String,
			default() {
				return "top";
			},
		},
	},
	methods: {
		show() {
			this.hidden = false;
		},
		hide() {
			this.hidden = true;
		},
	},
};
</script>
